import type {
	ClassifierCategory,
	PiiScanTemplateType,
	PolicyOut,
	PolicyRuleOut,
	PolicyTemplate,
} from '@repo/api-codegen';
import { useMemo, useRef } from 'react';
import { useAutomation } from '../../../api/hooks/automation';
import { CreatePolicyStore } from './CreatePolicyStore';
import { CreatePolicyStoreContext } from './contextStore';

export function CreatePolicyStoreProvider({
	policy,
	policyTemplate,
	policyRules,
	owners,
	subscribers,
	piiScanMetadata,
	children,
}: {
	policy?: PolicyOut;
	policyTemplate?: PolicyTemplate;
	policyRules?: PolicyRuleOut[];
	owners?: string[];
	subscribers?: string[];
	piiScanMetadata?: {
		templateTitle: PiiScanTemplateType;
		templatePiiClassifiers: ClassifierCategory[];
	};
	children: React.ReactNode;
}) {
	const { data: automation } = useAutomation({
		id: policy?.automation_id ?? '',
		options: {
			enabled: !!policy?.automation_id,
		},
	});

	const storeRef = useRef<CreatePolicyStore | null>(null);

	const store = useMemo(() => {
		const newStore = new CreatePolicyStore({
			policy,
			policyTemplate,
			policyRules,
			owners,
			subscribers,
			piiScanMetadata,
		});

		if (automation?.title) {
			newStore.setAutomationData(automation);
		}

		storeRef.current = newStore;
		return newStore;
	}, [
		policy,
		policyTemplate,
		policyRules,
		automation,
		owners,
		subscribers,
		piiScanMetadata,
	]);

	return (
		<CreatePolicyStoreContext.Provider value={store}>
			{children}
		</CreatePolicyStoreContext.Provider>
	);
}
